export const FETCH_CONTACT_METHODS_REQUEST = "FETCH_CONTACT_METHODS_REQUEST";
export const CREATE_CONTACT_METHOD_REQUEST = "CREATE_CONTACT_METHOD_REQUEST";
